<template>
  <div style="text-align:center;">
    <Loading v-if="loading" />
    <h1>Opt-Out Successful</h1>
    <p style="font-weight:bold;">
      You have been opted out of the RDC Scanner Upgrade program communications.
    </p>
    <p>
      If you find that you need additional help, then you can schedule a call
      with our
      <router-link
        to="/booking"
        style="color:var(--secondary-color);font-weight:bold;"
        >Technical Assistance Center</router-link
      >
      here.
    </p>
    <p style="color:var(--secondary-color);font-weight:bold;">
      For assistance, please call an RDC Specialist at
      {{ apidata.system.booking_phone }}.
    </p>
    <div class="dashboard-booking-footer">
      If you need assistance, please call {{ apidata.system.booking_phone }}
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      loading: false,
    };
  },

  methods: {
    doAction: async function() {
      try {
        this.loading = true;
        const ticket_id = this.$route.query?.ticket_id;
        if (!ticket_id)
          throw new Error("This action requires a ticket ID in the URL.");

        await this.$axios({
          method: "post",
          url: "https://enrcv3w0p0qf10n.m.pipedream.net",
          params: {
            system_id: this.apidata.system.system_id,
            ticket_id,
            action: "opt-out",
          },
        });
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },

  created: async function() {
    await this.doAction();
  },
};
</script>
